import jsPDF from "jspdf";

export const PAGE_W = 210;
export const MARGIN_X = 18;
export const CONTENT_W = PAGE_W - MARGIN_X * 2;

export function ensureSpace(doc: jsPDF, y: number, needed: number, top = 18): number {
  const pageHeight = doc.internal.pageSize.getHeight();
  if (y + needed > pageHeight - 15) { doc.addPage(); return top; }
  return y;
}

export function imgFormat(src: string): string {
  if (src.startsWith("data:image/png")) return "PNG";
  if (src.startsWith("data:image/webp")) return "WEBP";
  return "JPEG";
}

export function drawHeader(doc: jsPDF, organizationName: string, orgBanner?: string | null, orgLogo?: string | null): number {
  if (orgBanner) {
    try {
      const props = doc.getImageProperties(orgBanner);
      const aspect = props.width / props.height;
      const displayH = Math.min(35, PAGE_W / aspect);
      const displayW = displayH * aspect;
      const xOff = (PAGE_W - displayW) / 2;
      doc.addImage(orgBanner, imgFormat(orgBanner), xOff, 0, displayW, displayH);
      let y = displayH + 5;
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9.5);
      doc.text("APPLICANT ASSESSMENT & ENDORSEMENT FORM", PAGE_W / 2, y, { align: "center" });
      y += 5;
      doc.setLineWidth(0.4);
      doc.line(MARGIN_X, y, PAGE_W - MARGIN_X, y);
      return y + 8;
    } catch { /* fall through */ }
  }

  if (orgLogo) {
    try {
      const logoSize = 18;
      doc.addImage(orgLogo, imgFormat(orgLogo), MARGIN_X, 6, logoSize, logoSize);
      const textX = MARGIN_X + logoSize + 4;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.text(organizationName.toUpperCase(), textX, 13);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9.5);
      doc.text("APPLICANT ASSESSMENT & ENDORSEMENT FORM", textX, 21);
      doc.setLineWidth(0.4);
      doc.line(MARGIN_X, 28, PAGE_W - MARGIN_X, 28);
      return 36;
    } catch { /* fall through */ }
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.text(organizationName.toUpperCase(), PAGE_W / 2, 18, { align: "center" });
  doc.setFontSize(11);
  doc.text("APPLICANT ASSESSMENT & ENDORSEMENT FORM", PAGE_W / 2, 25, { align: "center" });
  doc.setLineWidth(0.4);
  doc.line(MARGIN_X, 28, PAGE_W - MARGIN_X, 28);
  return 36;
}
